const CarePlanEmailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="40"
    viewBox="0 0 50 40"
    fill="none"
  >
    <path
      d="M45 10L25 22.5L5 10V5L25 17.5L45 5M45 0H5C2.225 0 0 2.225 0 5V35C0 36.3261 0.526784 37.5979 1.46447 38.5355C2.40215 39.4732 3.67392 40 5 40H45C46.3261 40 47.5979 39.4732 48.5355 38.5355C49.4732 37.5979 50 36.3261 50 35V5C50 3.67392 49.4732 2.40215 48.5355 1.46447C47.5979 0.526784 46.3261 0 45 0Z"
      fill="#FB9318"
    />
  </svg>
);

export default CarePlanEmailIcon;
